import React from 'react';

export default function LoadingSpinner({ fullPage = false }) {
  const spinner = (
    <div style={{
      width: 36, height: 36,
      border: '3px solid var(--color-border)',
      borderTopColor: 'var(--color-accent)',
      borderRadius: '50%',
      animation: 'spin .6s linear infinite',
    }} />
  );

  return fullPage ? (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100dvh',
    }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {spinner}
    </div>
  ) : (
    <>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {spinner}
    </>
  );
}
